export const CoreConfig = {
    provider: Symbol('Core'),
    moduleName: 'application'
};
export const CoreConstants = {
    push_notification_status: {
        pending: 500,
        sent: 1000,
        failed: 1500,
        delivered: 2000,
        seen: 3000
    },
    errors: {
        service_unavailable: 503,
        unauthorized: 5142,
        invalid_profile: 5141,
        request_timeout: -1,
        maintenance: -2,
        offline: -3
    }
};
